import { art } from '@/lib/skin';
/** First paint while the session loads: the brand mark on dusk. */
export function Splash() {
  return (
    <div className="screen" style={{ alignItems: 'center', justifyContent: 'center' }}>
      <img src={art('/logo/baby-plan-mark.svg')} alt="Baby Plan" width={88} height={88} />
    </div>
  );
}
